module.exports = "https://assets.bwbx.io/s3/reg2/images/favicon-32x32-d2b81a93733e8f9ea67c.png";